import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

/**
 * Page layout — fixed full-viewport height, flex-row
 */
export const PageContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  height: "calc(100vh - 88px)", // minus top navbar height
  overflow: "hidden",
  backgroundColor: "#f9f9f9",
}));

/**
 * Sidebar with chat interface
 */
export const SidebarContainer = styled(Box)(() => ({
  width: "400px",
  minWidth: "320px",
  borderRight: "1px solid #e0e0e0",
  backgroundColor: "#ffffff",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  overflow: "hidden",
}));

/**
 * Right side — filters, product grid, pagination
 */
export const MainContent = styled(Box)(() => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  backgroundColor: "#fafafa",
}));

/**
 * Content area (filters + grid)
 */
export const ContentContainer = styled(Box)(() => ({
  padding: "12px 24px",
  borderBottom: "1px solid #e0e0e0",
  flexShrink: 0,
  backgroundColor: "#fff",
}));

/**
 * Product grid scrollable region
 */
export const ProductCardGrid = styled(Box)(() => ({
  flex: 1,
  overflowY: "auto",
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
  gap: "16px",
  padding: "16px 24px",
}));
